<template>

  <v-dialog
    v-model="show"
    persistent
    max-width="370">
    <v-card color="secondary" dark>
        <v-card-text class="pa-4 subtitle-1">
          <v-form
                ref="form"
                v-model="valid"
                lazy-validation
              >
                  <v-text-field
                    v-model="discount.description"
                    label="Description"
                    :rules="textRules"
                    required
                    outlined
                    dense
                  />
                    <v-text-field
                    v-model="discount.amount"
                    label="Amount"
                    :rules="textRules"
                    required
                    outlined
                    dense
                  />
          </v-form>
        </v-card-text>
        <v-card-actions>
                <v-btn color="warning" small text rounded  @click="text ='close', emitToParent()">Cancel</v-btn>
            <v-spacer></v-spacer>
            <v-btn  small color="success"  rounded  @click="validate()">Add</v-btn>
        </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
    data: () => ({
        discount: {},
        valid: true,
        textRules: [
        v => !!v || 'Field is required'
      ],
    }),
  props: {
    show: {
        type: Boolean,
        default: false
    }
  },
  watch:{
      show(val) {
          if(!val){this.discount={}}
      }
  },
  methods: {
    emitToParent () {
      this.$emit('DialogEvent', "close")
    },
    validate () {
      if (this.$refs.form.validate()) {
        this.discount.description = this.discount.description.trim()
         this.discount.amount = this.discount.amount.trim()
           this.$emit('DialogEvent', this.discount)
      }
    }
  }
}
</script>
